import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { Wrapper, CardBody, Title } from "app/NativeComponents/common";

const ZapierOptions = () => {
  const { device } = useSelector(({ native }) => native);
  const { user } = useSelector(({ auth }) => auth);

  useEffect(() => {
    if (
      device == "desktop" &&
      (user.team_clearance_level > 1 || user.can_export_data == 1)
    ) {
      // Inject zapier
      var elem = document.createElement("script");
      elem.id = "zapier_script";
      elem.src =
        "https://zapier.com/apps/embed/widget.js?guided_zaps=25148,25153,25156&html_id=zapier";
      document.body.appendChild(elem);
    }

    // Remove zapier at unmount
    return () => {
      if (
        device == "desktop" &&
        (user.team_clearance_level > 1 || user.can_export_data == 1)
      ) {
        var element = document.getElementById("zapier_script");
        element.parentNode.removeChild(element);
      }
    };
  }, [device, user]);

  if (device == "desktop")
    return (
      <Wrapper>
        <CardBody>
          <Title>Integrate your account with Zapier:</Title>
        </CardBody>
        <div id="zapier" />
      </Wrapper>
    );
  return <Wrapper />;
};

export default ZapierOptions;
